<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>小睿智能筛查管家</el-breadcrumb-item>
      <el-breadcrumb-item>微信用户</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.userid" @keyup.enter.native="clicksearch" placeholder="请输入编号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.identity" placeholder="请选择身份" class="select" style="width: 150px;">
              <el-option label="请选择身份" value="-1"></el-option>
              <el-option label="普通用户" value="0"></el-option>
              <el-option label="店员" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.phone" @keyup.enter.native="clicksearch" placeholder="请输入手机号码" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="Userid" label="ID" min-width="10%"></el-table-column>
          <el-table-column prop="Identitys" label="身份" min-width="10%"></el-table-column>
          <el-table-column prop="Phone" label="手机号码" min-width="10%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="10%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="10%">
            <template v-slot="scope">
              <el-button v-if="SubRule_Miniappshaicha_SetWxuserIdentity" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickset(scope.row,0)">设置为普通用户</el-button>
              <el-button v-if="SubRule_Miniappshaicha_SetWxuserIdentity" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickset(scope.row,1)">设置为店员</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clicksublist(scope.row)">视力筛查人员</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 添加 end -->
    <el-tab-pane label="视力筛查人员" name="six" disabled="disabled">
      <MiniappshaichaWxuserSub ref="SubVuesix" v-on:triggerFunc="BackToFirst(0)"></MiniappshaichaWxuserSub>
    </el-tab-pane>

  </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import MiniappshaichaWxuserSub from '@/componentsSubVue/MiniappshaichaWxuserSub.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    MiniappshaichaWxuserSub
  },
  name: 'MyMiniappshaichaWxuser',
  data () {
    return {
      activeName: 'first',
      // 查询
      keywords: {
        userid: '',
        identity: '-1',
        phone: ''
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      SubRule_Miniappshaicha_SetWxuserIdentity: false
    }
  },
  mounted () {
    this.apiGetMiniappShaichaWxuserNum()
    this.apiGetMiniappShaichaWxuserList()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_Miniappshaicha_SetWxuserIdentity', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Miniappshaicha_SetWxuserIdentity = true
      }
    })
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
    },
    clickadd () {
      this.apiAddVisitorslog()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clickset (row, identity) {
      this.apiSetMiniappShaichaWxuser(row.Id, identity)
    },
    clicksublist (row) {
      this.activeName = 'six'
      this.$refs.SubVuesix.LoadData({ name: '', params: { Openid: row.Openid } })
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetMiniappShaichaWxuserNum()
      this.apiGetMiniappShaichaWxuserList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetMiniappShaichaWxuserList()
    },
    apiGetMiniappShaichaWxuserNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        userid: that.keywords.userid,
        identity: that.keywords.identity,
        phone: that.keywords.phone
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetMiniappShaichaWxuserNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetMiniappShaichaWxuserList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        userid: that.keywords.userid,
        identity: that.keywords.identity,
        phone: that.keywords.phone
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetMiniappShaichaWxuserList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiSetMiniappShaichaWxuser: function (id, identity) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id,
        identity: identity
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_SetMiniappShaichaWxuser, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetMiniappShaichaWxuserNum()
            that.apiGetMiniappShaichaWxuserList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
